<div class="row">
  <div class="col-sm-12">
    <p-fileupload
      [url]="uploadPath"
      name="upload"
      mode="basic"
      auto="auto"
      multiple="multiple"
      [chooseButtonProps]="{
        severity: 'primary',
        variant: outlined() ? 'outlined' : 'text',
        size: 'small',
      }"
      [chooseLabel]="label()"
      (onBeforeUpload)="onBeforeUpload()"
      (onUpload)="onUploadResponse($event)"
      [maxFileSize]="10 * 1024 * 1024"
    ></p-fileupload>
    @if (!outlined()) {
      (max. 10MB)
    }
    @if (loading) {
      <i class="pi pi-spinner"></i>
    }
  </div>
</div>

@if (showUploadedFile() && uploadedFileUrl) {
  <div class="row upload-details">
    <div class="col-sm-12">
      <strong>Uploaded file: </strong>
      <a [href]="uploadedFileUrl" target="_blank">
        {{ uploadedfileName }}
      </a>
    </div>
  </div>
}
